import styled from "styled-components";
import { Link } from "react-router-dom";

export const DebtBreadcrumb = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: #6b7280;
	padding: 16px 0px;
`;

export const BreadcrumbItem = styled.span<{ active?: boolean }>`
	color: ${(props) => (props.active ? "#9CA3AF" : "#374151")};
	cursor: ${(props) => (props.active ? "default" : "pointer")};

	&:hover {
		color: ${(props) => (props.active ? "#9CA3AF" : "#1F2937")};
	}
`;

export const BreadcrumbSeparator = styled.img`
	width: 12px;
	height: 12px;
	margin: 0 4px;
`;

export const DebtContainer = styled.div`
	width: 1200px;
	position: relative;
	margin: 0 auto;
	max-width: 1440px;
	padding: 24px 0 40px;
	font-size: 16px;
	justify-content: space-between;
	background-color: #f3f4f6;

	@media screen and (max-width: 768px) {
		margin: 0;
		width: 100%;
		padding: 0 16px 16px 16px;
		height: inherit;
		align-items: center;
	}
`;

export const DebtTitle = styled.h1`
	font-size: 24px;
	font-weight: 600;
	color: #111827;
	margin: 0 0 32px 0;

	@media screen and (max-width: 768px) {
		font-size: 18px;
		margin: 0 0 20px 0;
	}
`;

export const DebtSummaryCards = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 30px;
	margin-bottom: 32px;

	@media screen and (max-width: 1200px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 16px;
	}

	@media screen and (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 12px;
	}
`;

export const DebtCard = styled.div<{ color: string }>`
	background-color: #f8f8f8;
	border-radius: 10px;
	padding: 20px;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	gap: 14px;
	border: 1px solid #dce0ea;
	cursor: pointer;
	transition: all 0.3s ease;

	@media screen and (max-width: 768px) {
		padding: 16px;
		gap: 12px;
	}

	&:hover {
		background-color: #005e9e;

		* {
			color: #ffffff !important;
		}
	}
`;

export const DebtCardIcon = styled.div<{ color: string }>`
	font-size: 20px;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const DebtCardContent = styled.div`
	flex: 1;
`;

export const DebtCardNumber = styled.div<{ color: string }>`
	font-size: 24px;
	font-weight: bold;
	color: ${(props) => props.color};
	margin-bottom: 4px;
`;

export const DebtCardAmount = styled.div<{ color: string }>`
	font-size: 14px;
	color: #363a3f;
	font-weight: 500;
`;

export const DebtCardText = styled.div`
	font-size: 14px;
	color: #363a3f;
	margin-bottom: 4px;
`;

export const DebtListSection = styled.div`
	background-color: #ffffff;
	border-radius: 10px;
`;

export const DebtListHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;

	@media screen and (max-width: 768px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 16px;
	}
`;

export const DebtListTitle = styled.h2`
	font-size: 18px;
	font-weight: bold;
	color: #111827;
	margin: 0;

	@media screen and (max-width: 768px) {
		font-size: 16px;
	}
`;

export const DebtActionButtons = styled.div`
	display: flex;
	gap: 12px;

	@media screen and (max-width: 768px) {
		width: 100%;
		justify-content: stretch;
	}
`;

export const DebtExportButton = styled.button`
	background-color: #3b82f6;
	color: white;
	border: none;
	border-radius: 8px;
	padding: 8px 16px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const DebtFilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	background-color: #ffffff;
	border-radius: 8px;
	padding: 20px 24px 18px;

	@media screen and (max-width: 768px) {
		padding: 16px 16px 0;
	}
`;

export const DebtFilterRow = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	width: 100%;
	justify-content: space-between;

	@media screen and (max-width: 768px) {
		flex-direction: column;
		align-items: stretch;
		gap: 12px;
	}
`;

export const DebtSearchInputWrapper = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	flex: 3;
`;

export const DebtSearchIcon = styled.img`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	width: 16px;
	height: 16px;
	pointer-events: none;
`;

export const DebtSearchInput = styled.input`
	box-sizing: border-box;
	min-height: 40px;
	height: 40px;
	padding: 0 16px 0 40px;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	font-size: 14px;
	flex: 1;
	background-color: #f9fafb;

	&::placeholder {
		color: #111827;
	}

	&:focus {
		outline: none;
		border-color: #e5e7eb;
	}
`;

export const DebtCheckbox = styled.label`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: #374151;
	cursor: pointer;
	white-space: nowrap;

	input[type="checkbox"] {
		width: 16px;
		height: 16px;
	}
`;

export const DebtTableCheckbox = styled.div<{ checked: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	cursor: pointer;
	position: relative;

	input[type="checkbox"] {
		position: absolute;
		opacity: 0;
		width: 100%;
		height: 100%;
		cursor: pointer;
		margin: 0;
		z-index: 1;
	}

	${(props) =>
		!props.checked
			? `
		&::before {
			content: '';
			position: absolute;
			width: 14px;
			height: 14px;
			border: 2px solid #035D9D;
			border-radius: 4px;
			background-color: white;
			transition: all 0.2s;
		}
	`
			: `
		&::before {
			content: '';
			position: absolute;
			width: 19px;
			height: 19px;
			background-image: url('./static/img/checkbox.png');
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center;
			transition: all 0.2s;
		}
	`}
`;

export const DebtSelect = styled.select`
	box-sizing: border-box;
	min-height: 40px;
	height: 40px;
	padding: 0 30px 0 12px;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	font-size: 14px;
	background-color: #f9fafb;
	flex: 0 1 168px;
	min-width: 128px;
	max-width: 220px;
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: right 8px center;
	cursor: pointer;

	&:focus {
		outline: none;
		border-color: #e5e7eb;
	}
`;

export const DebtFilterInput = styled.input`
	padding: 12px 16px;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	font-size: 14px;
	background-color: #f9fafb;
	flex: 1;
	min-width: 0;

	&:focus {
		outline: none;
		border-color: #e5e7eb;
	}
`;

export const DebtFilterButton = styled.button`
	box-sizing: border-box;
	min-height: 40px;
	height: 40px;
	padding: 0 22px;
	background-color: #005e9e;
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	flex: 0 0 auto;
	white-space: nowrap;
	display: inline-flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: #004a7c;
	}
`;

/** Toolbar for Station Request List filters — single wrap row, aligned controls */
export const StationRequestFilterToolbar = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 10px 12px;
	width: 100%;

	${DebtSearchInputWrapper} {
		flex: 1 1 260px;
		min-width: 200px;
		max-width: 440px;
	}

	@media screen and (max-width: 768px) {
		flex-direction: column;
		align-items: stretch;
		gap: 10px;

		${DebtSearchInputWrapper} {
			max-width: none;
			width: 100%;
		}

		${DebtSelect} {
			max-width: none;
			width: 100%;
			flex: 1 1 auto;
		}

		${DebtFilterButton} {
			width: 100%;
		}
	}
`;

export const DebtTableEmptyPanel = styled.div`
	box-sizing: border-box;
	width: calc(100% - 32px);
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	padding: 48px 24px;
	background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
	border: 1px dashed #e5e7eb;
	border-radius: 12px;
	margin: 8px 16px 16px;
	color: #64748b;
	font-size: 14px;
	line-height: 1.6;

	strong {
		display: block;
		color: #334155;
		font-size: 15px;
		font-weight: 600;
		margin-bottom: 8px;
	}
`;

export const DebtTable = styled.div`
	width: 100%;
	overflow-x: auto;

	@media screen and (max-width: 768px) {
		-webkit-overflow-scrolling: touch;
	}
`;

export const DebtTableHeader = styled.div`
	display: grid;
	grid-template-columns: 44px minmax(220px, 1.4fr) 170px 140px 110px 140px 120px 140px 130px;
	gap: 12px;
	align-items: start;
	font-weight: 600;
	font-size: 12px;
	color: #6b7280;
	padding: 16px 16px 5px;
	border-bottom: 1px solid #e5e7eb;

	@media screen and (max-width: 768px) {
		min-width: 1400px;
		font-size: 10px;
		padding: 12px 8px 4px;
		gap: 8px;
	}
`;

export const DebtTableRow = styled.div<{ backgroundColor: string }>`
	display: grid;
	grid-template-columns: 44px minmax(220px, 1.4fr) 170px 140px 110px 140px 120px 140px 130px;
	gap: 12px;
	align-items: center;
	padding: 16px;
	background-color: ${(props) => props.backgroundColor};
	border-bottom: 1px solid #e5e7eb;
	font-size: 14px;
	color: #374151;

	@media screen and (max-width: 768px) {
		min-width: 1400px;
		font-size: 12px;
		padding: 12px 8px;
		gap: 8px;
	}

	&:hover {
		background-color: #dbeafe;
	}
`;

export const DebtTableCell = styled.div<{ alignRight?: boolean }>`
	display: flex;
	align-items: start;
	gap: 4px;
	white-space: pre-line;
	justify-content: ${(props) => (props.alignRight ? "flex-end" : "flex-start")};

	input[type="checkbox"] {
		width: 16px;
		height: 16px;
	}
`;

export const DebtStatusBadge = styled.span<{ backgroundColor: string; textColor: string }>`
	background-color: ${(props) => props.backgroundColor};
	color: ${(props) => props.textColor};
	padding: 6px 12px;
	border-radius: 16px;
	font-size: 12px;
	font-weight: 500;
	margin-right: 8px;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	white-space: nowrap;

	&::before {
		content: "";
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background-color: ${(props) => props.textColor};
		flex-shrink: 0;
	}
`;

export const DebtHeaderActionButton = styled.button<{ backgroundColor: string; textColor: string }>`
	background-color: ${(props) => props.backgroundColor};
	color: #111827;
	border-radius: 8px;
	padding: 12px 16px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	margin-right: 8px;
	display: flex;
	align-items: center;
	border: none;
	transition: all 0.2s ease;

	@media screen and (max-width: 768px) {
		width: 100%;
		justify-content: center;
		padding: 10px;
		font-size: 12px;
	}
`;

export const DebtTableActionButton = styled.button<{ backgroundColor: string; textColor: string }>`
	background-color: ${(props) => props.backgroundColor};
	color: ${(props) => props.textColor};
	border-radius: 8px;
	padding: 6px 10px;
	font-size: 12px;
	font-weight: 500;
	cursor: pointer;
	margin-right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;
	border: none;
	transition: all 0.2s ease;
`;

export const DebtPayActionButton = styled.button`
	background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
	color: #ffffff;
	border: 1px solid rgba(21, 128, 61, 0.3);
	border-radius: 999px;
	padding: 8px 16px;
	min-height: 36px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;
	box-shadow: 0 6px 14px rgba(34, 197, 94, 0.22);
	transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 10px 20px rgba(34, 197, 94, 0.28);
		filter: saturate(1.05);
	}

	&:active {
		transform: translateY(0);
	}

	&:disabled {
		opacity: 0.65;
		cursor: not-allowed;
		box-shadow: none;
		transform: none;
	}
`;

export const DebtActionButton = styled.button<{ backgroundColor: string; textColor: string }>`
	background-color: ${(props) => props.backgroundColor};
	color: #111827;
	border-radius: 6px;
	padding: 10px 15px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	margin-right: 8px;
	display: flex;
	align-items: center;
	border: none;
`;

export const DebtDetailsLink = styled(Link)`
	color: #035d9d;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;

	&:hover {
		text-decoration: none;
	}
`;

export const BulkActionButtons = styled.div`
	display: flex;
	gap: 12px;
	justify-content: flex-end;
	margin: 0;
	transition: all 0.3s ease;
	opacity: 1;
	transform: translateY(0);
`;

export const BulkActionButton = styled.button<{ variant: "approve" | "cancel" }>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 4px 12px;
	border-radius: 6px;
	border: none;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;

	${(props) =>
		props.variant === "approve"
			? `
		background-color: #10B981;
		color: white;
		
		&:hover {
			background-color: #059669;
		}
	`
			: `
		background-color: #EF4444;
		color: white;
		
		&:hover {
			background-color: #DC2626;
		}
	`}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export const DebtProcessingCell = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const DebtProcessingBadge = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 4px 10px;
	border-radius: 12px;
	background-color: #fef3f2;

	&::before {
		content: "";
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background-color: #b42318;
		flex-shrink: 0;
	}
`;

export const DebtProcessingText = styled.span`
	font-size: 12px;
	font-weight: 500;
	color: #b42318;
`;

export const DebtCHTag = styled.span`
	background-color: #10b981;
	color: white;
	font-size: 10px;
	font-weight: 600;
	padding: 2px 6px;
	border-radius: 4px;
	margin-left: auto;
`;

export const DebtApproveActionButton = styled.button`
	background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%);
	color: #ffffff;
	border: 1px solid rgba(29, 78, 216, 0.3);
	border-radius: 999px;
	padding: 6px 13px;
	min-height: 32px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;
	box-shadow: 0 4px 10px rgba(59, 130, 246, 0.22);
	transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 8px 16px rgba(59, 130, 246, 0.3);
		filter: saturate(1.05);
	}

	&:active {
		transform: translateY(0);
	}

	&:disabled {
		opacity: 0.65;
		cursor: not-allowed;
		box-shadow: none;
		transform: none;
	}
`;

export const DebtRejectActionButton = styled.button`
	background: #ffffff;
	color: #b91c1c;
	border: 1px solid #fca5a5;
	border-radius: 999px;
	padding: 6px 13px;
	min-height: 32px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;
	transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;

	&:hover {
		background: #fef2f2;
		border-color: #f87171;
	}

	&:active {
		background: #fee2e2;
	}

	&:disabled {
		opacity: 0.65;
		cursor: not-allowed;
	}
`;
